<template>
  <div>
    <b-container fluid class="content">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-body>
              <b-form>
                <b-row class="border-bottom mb-2">
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        StoreID
                      </b-col>
                      <b-col class="col-7">
                        {{ StoreID }}
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-4 font-weight-bold text-sm-right">
                        <label for="api-key">{{ $t('Order Api') }}</label>
                      </b-col>
                      <b-col class="col-4">
                        <b-form-input class="form-check-input mt-0" id="api-key" v-model="ApiKey" size="sm"></b-form-input>
                      </b-col>
                      <b-col class="col-2">
                        <b-button @click="new_api_key" variant="success" size="sm">{{ $t('New') }}</b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <label for="mini-time-gap">{{ $t('Minimum Interval Seconds') }}</label>
                      </b-col>
                      <b-col class="col-7">
                        <b-form-input class="form-check-input mt-0" id="mini-time-gap" v-model="MiniTimeGap" size="sm"></b-form-input>
                        <b-tooltip target="mini-time-gap" triggers="hover">
                          0 is no limit
                        </b-tooltip>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="border-bottom mb-2">
                  <b-col cols="1">
                    <label for="ip-list">Allowed IPs</label>
                  </b-col>
                  <b-col cols="10">
                    <b-form-tags input-id="ip-list" v-model="AllowedIP" tag-variant="primary" tag-pills size="lg" tagClass="tag-content" placeholder="If empty, will allowe all IP access. Otherwise only listed IP can access"></b-form-tags>
                  </b-col>
                </b-row>
                <b-row class="justify-content-lg-center mt-3">
                  <b-col class="text-center">
                    <el-button type="primary" @click="form_cancel">{{ $t("Back")}}</el-button>
                  </b-col>
                  <b-col class="text-center">
                    <el-button type="primary" @click="form_submit">{{ $t("Submit") }}</el-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>
          <b-card v-if="logs.length>0">
            <b-card-body>
              <b-row class="justify-content-lg-center mt-1" v-for="log in logs" :key="log.IDn">
                <b-col cols="1">{{ log.StoreID }}({{ log.IDn }})</b-col>
                <b-col cols="1">{{ log.IP }}</b-col>
                <b-col cols="1">{{ log.LastUpdate }}</b-col>
                <b-col cols="3">{{ log.HData }}</b-col>
                <b-col cols="3">{{ log.PData }}</b-col>
                <b-col cols="3">{{ log.RData }}</b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-4" v-if="text_message">
        <b-col>
          <b-card no-body>
            {{ text_message }}
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <div class="loading-overlay" v-if="show_loading">
      <div class="spinner"></div>
      <p>Loading...</p>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Button, DatePicker, } from "element-ui";
import { getStore, setStore } from "../../util/helper";
import { hasUtilityAuth } from "../../directives/acl";

const axios = require("axios");

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
  },
  data() {
    return {
      show_loading: false,
      IDn: 0,
      StoreID: '',
      ApiKey: '',
	    InputIP: '',
	    AllowedIP: [],
      MiniTimeGap: 0,

	    logs: [],

      store: {},
      pkadmin: false,

      token: "",
      user_id: 0,

      text_message: "",
    };
  },
  methods: {
    hasUtilityAuth,
    new_api_key() {
      const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#%^&*-_=+";
      const array = new Uint32Array(32);
      crypto.getRandomValues(array);
      this.ApiKey = Array.from(array, x => charset[x % charset.length]).join('');
    },
    addIp() {
      const ipRegex =/^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
       if (!ipRegex.test(this.InputIP)) {
        alert("Invalid IP address");
        return;
      }
      if (this.AllowedIP.includes(this.InputIP)) {
        alert("IP already exists");
        return;
      }
      this.AllowedIP.push(this.InputIP);
      this.InputIP = "";
    },
    handleClose(para, idx) {
      if (idx > -1 && idx < para.length) {
        para.splice(idx, 1);
      }
    },
    form_cancel() {
      this.show_loading = false;
      this.$router.push("/store");
    },
    async form_submit(event) {
      this.showUpdatedStore = false;
      if (event) {
        event.preventDefault();
      }
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", this.IDn);
      bodyFormData.append("StoreID", this.StoreID);
      bodyFormData.append("ApiKey", this.ApiKey);
      bodyFormData.append("MiniTimeGap", this.MiniTimeGap);
      if (this.AllowedIP.length < 1) {
        bodyFormData.append("AllowedIP", "[]");
      } else {
        bodyFormData.append("AllowedIP", JSON.stringify(this.AllowedIP));
      }
      this.show_loading = true;
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/orderapi/update",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (rt.data.store && rt.data.store.StoreID) {
                that.IDn = rt.data.store.IDn;
                that.StoreID = rt.data.store.StoreID;
                that.ApiKey = rt.data.store.ApiKey;
                try {
                  that.AllowedIP = JSON.parse(rt.data.store.AllowedIP);
                } catch (err) {
                  that.AllowedIP = [];
                }
                that.MiniTimeGap = rt.data.store.MiniTimeGap;
              }
              if (rt.data.logs) {
                that.logs = rt.data.logs;
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        })
        .finally(() => {
          that.show_loading = false;
        });
    },
    async get_order_api() {
      // this will be called only after form is valid. You can do api call here to login
      this.text_message = "";
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("StoreID", this.StoreID);
      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/orderapi",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            const rt = response.data;
            if (rt.status == 0) {
              if (rt.data.store && rt.data.store.StoreID) {
                that.IDn = rt.data.store.IDn;
                that.StoreID = rt.data.store.StoreID;
                that.ApiKey = rt.data.store.ApiKey;
                try {
                  that.AllowedIP = JSON.parse(rt.data.store.AllowedIP);
                } catch (err) {
                  that.AllowedIP = [];
                }
                that.MiniTimeGap = rt.data.store.MiniTimeGap;
              }
              if (rt.data.logs) {
                that.logs = rt.data.logs;
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
            that.$router.push("/login");
          }
        })
        .catch(function (error) {
          that.$router.push("/login");
        });
    },
    async init_data() {
      this.token = getStore("token");
      this.user_id = getStore("user_id");
      if (!this.token || !this.user_id) {
        this.$router.push("/login");
        return;
      }
      this.StoreID = this.$route.query.StoreID;
      if (!this.StoreID) {
        this.$router.push("/store");
        return;
      }
      try {
        this.get_order_api();
      } catch (err) {
        console.log("init_data catch", err);
      }
    },
  },
  computed: {
    // curTimes() {
    //   let tms = [];
    //   if (this.timeSlots && (this.timeSlots.length > 1)) {
    //     for (let i = 0; i < this.timeSlots.length; i++) {
    //       tms.push(JSON.parse(JSON.stringify(this.timeSlots[i])));
    //     }
    //   }
    //   return tms;
    // },
  },
  mounted() {
    let name = getStore("username");
    if (name && name != undefined && ((name == "PKAdmin") || (name == "posking"))) {
      this.pkadmin = true;
    } else {
      this.$router.push("/store");
      return;
    }

    this.init_data();
    this.windowHeight = window.innerHeight;
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding-top: 80px;
}
.form-control-lg {
  padding: 0;
}
/deep/.text-truncate {
  padding: 0 .5rem .25rem .5rem;
  font-size: 1rem;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  border: 8px solid rgba(0, 0, 0, 0.1);
  border-top: 8px solid #3498db; /* Change this color as needed */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
